import { actionTypes } from '../../types';

// Action request
export const getWalletTxnWithFilterForAgency = (payload, callback) => ({
    type: actionTypes.GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_REQUEST,
    payload,
    callback
});

// Action success
export const getWalletTxnWithFilterForAgencySuccess = (payload) => ({
    type: actionTypes.GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_SUCCESS,
    payload,
});

// Action failure
export const getWalletTxnWithFilterForAgencyFailure = (payload) => ({
    type: actionTypes.GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_FAILURE,
    payload,
});

// Action reset status
export const getWalletTxnWithFilterForAgencyReset = () => ({
    type: actionTypes.GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_RESET,
});

// Action reset all reducer
export const getWalletTxnWithFilterForAgencyResetAll = () => ({
    type: actionTypes.GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_RESET_ALL,
});
